import * as types from "./types";

const initialState = {
  rows: [],
  loading: false,
  error: null,
};

export default function limitReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_PRODUCT:
      return {
        ...state,
        product: action.payload,
      };
    case types.ADD_PRODUCT:
      return {
        ...state,
        added_product: action.payload,
      };

    case types.UPDATE_PRODUCT:
      return {
        ...state,
        updated_product: action.payload,
      };
    case types.DELETE_PRODUCT:
      return {
        ...state,
        deleted_product: action.payload,
      };
    case types.APPROVE_PRODUCT:
      return {
        ...state,
        approving: action.payload,
      };
   

    default:
      return state;
  }
}
